import axios from 'axios';
import { API_URL } from '../config';

/** Open Complic Code panel on the shared project checkout / agent branch. */
export function openAgentVscode(runId: string) {
  window.dispatchEvent(
    new CustomEvent('complic-open-vscode', { detail: { runId } })
  );
}

export async function resolveAgentVscodeFolder(runId: string): Promise<{
  folder: string;
  branch: string;
  ticket_key?: string | null;
}> {
  const res = await axios.get(`${API_URL}/api/agents/runs/${runId}/vscode`);
  return res.data;
}
